// ═══════════════════════════════════════════════════════════════════════
// data/coFundAllocations.js — platform_cofunding table access (migration 045).
// ═══════════════════════════════════════════════════════════════════════
// Thin Supabase wrappers for platform-contribution (co-funded discount) CRUD,
// mirroring data/cpcAllocations.js. Each returns the raw Supabase `{ data, error }`.
// RLS (mirrors cpc_allocations / daily_logs) is the security boundary.
// update/delete add .select() so a 0-row result (RLS USING silently excluded the
// row, e.g. the trial lapsed) is detectable by the caller: data.length === 0.
// Payload columns: workspace_id, channel_id, platform, date_from, date_to,
// discount_pct, cofund_pct (FRACTIONS, 0.45 = 45%; DATE columns as "YYYY-MM-DD").
import { supabase } from "../lib/supabaseClient";

export function insertCoFundAllocation(payload) {
  return supabase.from("platform_cofunding").insert(payload).select().single();
}

export function updateCoFundAllocation(id, payload) {
  return supabase.from("platform_cofunding").update(payload).eq("id", id).select();
}

export function deleteCoFundAllocation(id) {
  return supabase.from("platform_cofunding").delete().eq("id", id).select();
}
